import { Flo } from '../../types/flo-auth-api'

export class WebosSubscriptionService implements ISubscriptionService {
  initialize() {
    console.log('WEBOS TODO')
  }

  getType(): string {
    return 'webos'
  }

  async getProducts() {
    console.log('WEBOS TODO')
    return []
  }

  buyProduct(): Promise<Purchase> {
    console.log('WEBOS TODO')
    return Promise.resolve(null)
  }

  createSubscription(
    offer: Flo.Offers.OffersResponseData,
    subscriptionId: string,
  ): Promise<Flo.Payments.SubscriptionResponse> {
    return Promise.resolve(null)
  }
}
